import { render } from "./RelatorioDespesasCentroCustoIndex.vue?vue&type=template&id=d9cd8150&scoped=true&ts=true"
import script from "./RelatorioDespesasCentroCustoIndex.vue?vue&type=script&lang=ts"
export * from "./RelatorioDespesasCentroCustoIndex.vue?vue&type=script&lang=ts"

import "./RelatorioDespesasCentroCustoIndex.vue?vue&type=style&index=0&id=d9cd8150&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9cd8150"]])

export default __exports__